import { render, staticRenderFns } from "./PxAutocompleteLocaisEntrega.vue?vue&type=template&id=388885a6&"
import script from "./PxAutocompleteLocaisEntrega.vue?vue&type=script&lang=js&"
export * from "./PxAutocompleteLocaisEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VListItemContent,VListItemSubtitle,VListItemTitle,VTooltip})
